import { lazyLoad } from 'utils/loadable';
export const OrderMapResultsLoadable = lazyLoad(
  () => import('app/components/Order/OrderDetails/OrderMapResults'),
  module => module.OrderMapResults,
);